var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedemptionIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8299 1.7928L5.17787 5.63676C4.28795 6.03228 3.70703 6.9222 3.70703 7.89864V13.7078C3.70703 20.5676 8.45327 26.9825 14.831 28.5398C21.2088 26.9825 25.955 20.5676 25.955 13.7078V7.89864C25.955 6.9222 25.3741 6.03228 24.4842 5.63676L15.8322 1.7928C15.2018 1.50852 14.4602 1.50852 13.8299 1.7928V1.7928ZM14.831 14.9315H23.483C22.828 20.0238 19.429 24.5599 14.831 25.9813V14.9438H6.17903V7.89864L14.831 4.05468V14.9315Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemptionIconDark);
export default __webpack_public_path__ + "static/media/RedemptionIconDark.a81a55dc9cd0b1ba22b9eb4359caaf13.svg";
export { ForwardRef as ReactComponent };